import { constants } from "../../../misc/helpers";
import MainTutorialScenario from "./MainTutorialScenario";

export default class MainTutorialScenarioEnd {
	constructor(private mainScenario: MainTutorialScenario) {
	}

	public start() {
		this.step16Congrats();
	}
	step16Congrats() {
		var context = this;
		var data = {
			disabled: true,
			onDone: () => {
				context.step17BackToMainMenu();
			}
		};
		
		context.mainScenario.playSound('5', '17', () => {
			data.disabled = false;
			context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.GenericModal, {
				text: "Return to the main menu",
				okBttn: {
					text: 'Main Menu',
					onClick: () => {
						context.step17BackToMainMenu();
					}
				}
			});
			context.mainScenario.playSound('5', '17-2', () => {
				
			});
		});
	}
	step17BackToMainMenu() {
		var context = this;
		context.mainScenario.showMainMenu();
	}
}